module.exports = __webpack_public_path__ + "img/7.f703a5e0.png";